<div class="modal-container">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-content">
      <h2 class="modal-title">{{ data.title || '¿Cómo deseas recibir tus USDT?' }}</h2>
      <p class="modal-subtitle">{{ data.subtitle || 'Elige qué hacer con los USDT que comprarás' }}</p>
    </div>
    <button class="close-button" (click)="onCancel()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Summary -->
  <div class="transaction-summary">
    <div class="summary-row">
      <span class="summary-label">Envías:</span>
      <span class="summary-value">{{ data.sendFormatted || formatCLP(data.clpAmount) }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">Recibes:</span>
      <span class="summary-value highlight">{{ data.receiveFormatted || formatUSDT(data.usdtAmount) }}</span>
    </div>
  </div>

  <!-- Options -->
  <div class="options-container">
    <!-- Option 1: Wallet -->
    <div
      class="option-card"
      [class.selected]="selectedOption === 'wallet'"
      (click)="selectOption('wallet')"
      role="button"
      tabindex="0"
      (keydown.enter)="selectOption('wallet')"
      (keydown.space)="selectOption('wallet')">
      <div class="option-radio">
        <div class="radio-outer">
          <div class="radio-inner" *ngIf="selectedOption === 'wallet'"></div>
        </div>
      </div>
      <div class="option-content">
        <div class="option-header">
          <span class="option-badge">Recomendado</span>
          <h3 class="option-title">
            <mat-icon class="option-icon">account_balance_wallet</mat-icon>
            {{ data.walletTitle || 'Guardar en Wallet Aguacate' }}
          </h3>
        </div>
        <p class="option-description">
          {{ data.walletDescription || 'Tus USDT quedarán disponibles en tu wallet Aguacate. Podrás retirarlos cuando quieras sin comisiones adicionales.' }}
        </p>
        <div class="option-benefits">
          <ng-container *ngIf="data.walletBenefits; else defaultBenefits">
            <span class="benefit" *ngFor="let benefit of data.walletBenefits"><mat-icon>check_circle</mat-icon> {{ benefit }}</span>
          </ng-container>
          <ng-template #defaultBenefits>
            <span class="benefit"><mat-icon>check_circle</mat-icon> Sin comisiones</span>
            <span class="benefit"><mat-icon>check_circle</mat-icon> Disponible al instante</span>
            <span class="benefit"><mat-icon>check_circle</mat-icon> Retira cuando quieras</span>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Option 2: Withdraw -->
    <div
      class="option-card"
      [class.selected]="selectedOption === 'withdraw'"
      (click)="selectOption('withdraw')"
      role="button"
      tabindex="0"
      (keydown.enter)="selectOption('withdraw')"
      (keydown.space)="selectOption('withdraw')">
      <div class="option-radio">
        <div class="radio-outer">
          <div class="radio-inner" *ngIf="selectedOption === 'withdraw'"></div>
        </div>
      </div>
      <div class="option-content">
        <div class="option-header">
          <h3 class="option-title">
            <mat-icon class="option-icon">send</mat-icon>
            {{ data.withdrawTitle || 'Retirar USDT inmediatamente' }}
          </h3>
        </div>
        <p class="option-description">
          {{ data.withdrawDescription || 'Envía los USDT directamente a una wallet externa. Deberás seleccionar un beneficiario en el siguiente paso.' }}
        </p>
        <div class="option-warning">
          <mat-icon>info</mat-icon>
          <span>{{ data.withdrawWarning || 'Requiere dirección de wallet válida' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="modal-actions">
    <button
      class="btn-cancel"
      (click)="onCancel()"
      [disabled]="isLoading">
      Cancelar
    </button>
    <button
      class="btn-confirm"
      (click)="onConfirm()"
      [disabled]="isLoading">
      <span *ngIf="!isLoading">Confirmar</span>
      <mat-icon *ngIf="isLoading" class="spinner">sync</mat-icon>
    </button>
  </div>
</div>
